import React, { Component, ReactNode } from "react";
import { awsRum } from "../..";
import ErrorPage from "../../containers/redirect-pages/error";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    awsRum.recordError(_.message);
    awsRum.recordError(_.stack);
    return { hasError: true };
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
